<div
    role="radioGroup"
    class="agpr-slideToggle"
>
    @for (option of options; track option.value; let i = $index) {
        <input
            type="radio"
            class="u-srOnly"
            [id]="id + '_slideToggleOption' + i"
            [value]="option.value"
            [attr.tabindex]="option.value === value ? '0' : '-1'"
            (focus)="focusToggle(true)"
            (blur)="focusToggle(false)"
            [(ngModel)]="value"
            (ngModelChange)="onRadioChanged($event)"
        >
        <div
            class="agpr-slideToggle-option"
            [ngClass]="{'agpr-slideToggle-icon': option.icon,
                    'agpr-slideToggle-text': option.label}">
            <label
                [id]="id + '_' + option.value"
                class="agpr-slideToggle-label"
                [ngClass]="{
                    'agpr-slideToggle-label--selected': value === option.value,
                    'agpr-slideToggle-label--focused': value === option.value && focused
                }"
                [for]="id + '_slideToggleOption' + i"
            >

                @if (option.label) {
                    <span class="agpr-slideToggle-labelText">
                        {{ option.label | localize }}
                    </span>
                } @else if (option.icon) {
                    <span
                        class="agpr-slideToggle-labelIcon"
                        role="img"
                        [ngClass]="[
                            value === option.value ? 'fa-solid' : 'fa-regular',
                            option.icon,
                            value === option.value ? 'agpr-slideToggle-icon--selected' : ''
                        ]"
                        [pTooltip]="option.tooltip | localize"
                        tooltipPosition="top"
                        >
                    </span>
                }
            </label>
        </div>
    }
</div>
